import type { ThemePresetId } from '~/theme/presets';

/**
 * Active Theme Preset
 * 
 * Switch between theme presets to change the entire app appearance:
 * - 'urban': Electric Blue & Sunset Orange - Vibrant, energetic, metropolitan (default)
 * - 'modern': Violet & Cyan - Creative, innovative, tech-forward
 * - 'professional': Navy Blue & Gold - Trustworthy, established, premium
 */
export const activeThemePreset: ThemePresetId = 'urban';

export const defaultColorScheme = 'light' as const;
export const defaultItemsPerPage = 12;

/**
 * Beta Badge Configuration
 * 
 * Controls the visibility of the beta badge on the app logo.
 * Set to true to show the badge, false to hide it.
 */
export const showBetaBadge = true;

/**
 * Active Countries Grid Configuration
 *
 * Controls the visibility of the active countries grid on the homepage.
 * Set to true to show the grid, false to hide it.
 */
export const showActiveCountriesGrid = false;

/**
 * Disclaimer Footer Link Configuration
 *
 * Controls whether the disclaimer page is linked from the footer's About
 * column. The page itself stays published and reachable at its own URL
 * either way; this only governs whether the site navigates to it.
 * Set to true to show the link, false to hide it.
 */
export const showDisclaimerFooterLink = false;